var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-contain"},[_c('img',{attrs:{"src":require("@/assets/logo@3x.png"),"alt":""}}),_c('div',{staticClass:"footer-contain"},[_c('span',{staticClass:"footer-tip"},[_vm._v("©2025Vtron . All rights reserved.")])])])
}]

export { render, staticRenderFns }